import { useEffect } from 'react';

const useMainContentScroll = (eventHandler: () => void, dependencies: any[] = []): void => {
  useEffect(() => {
    const mainContent = document.getElementById('main-content');
    mainContent?.addEventListener('scroll', eventHandler);

    return () => {
      mainContent?.removeEventListener('scroll', eventHandler);
    };
  }, dependencies);
};

export default useMainContentScroll;
